import React from "react";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

const CostingForm = ({ formData, handleChange, costAndSellOptions }) => {
  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-12 col-lg-8 px-4">
          <div
            className="card shadow-none bg-light border"
            style={{ padding: "20px", maxWidth: "100%" }}
          >
            <div className="card-body">
              <h5 className="card-title mb-4 text-danger">Costing</h5>
              <div className="row g-3">
                <div className="col-12">
                  <label className="form-label">
                    Cost Type
                    <Tooltip
                      title={
                        <span style={{ fontSize: ".8rem" }}>
                          Cost calculated/evaluated per unit (e.g.,
                          Brackets are calculated individually, therefore,
                          the <span className="text-danger">Costing Unit</span> will be Cost/Unit)
                        </span>
                      }
                      arrow
                    >
                      <IconButton size="small" sx={{ color: "#fff" }}>
                        <HelpOutlineIcon fontSize="inherit" />
                      </IconButton>
                    </Tooltip>
                  </label>
                  <select
                    className="form-select"
                    name="costType"
                    value={formData.costType || ""}
                    onChange={handleChange}
                  >
                    <option value="">Select Cost Type</option>
                    {costAndSellOptions.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Conditionally render Cost Value field */}
                {formData.costType && (
                  <div className="col-12">
                    <label className="form-label">
                      Cost Value
                      <Tooltip
                        title={
                          <span style={{ fontSize: ".8rem" }}>
                            Enter the <span className="text-danger">cost</span> associated with the item.
                          </span>
                        }
                        arrow
                      >
                        <IconButton size="small" sx={{ color: "#fff" }}>
                          <HelpOutlineIcon fontSize="inherit" />
                        </IconButton>
                      </Tooltip>
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Enter Cost Value"
                      name="costValue"
                      value={formData.costValue || ""}
                      onChange={handleChange}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CostingForm;
